import { AlignLeft } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgAlignLeft = mkIcon(AlignLeft);